import React, { useEffect } from "react";
import lang from "../../helper/langHelper";
import {
  Form,
  Input,
  Select,
  Button,
  Card,
  Row,
  Col,
  Upload,
  DatePicker,
  TimePicker,
  Table,
  Pagination,
  Tooltip,
  Modal,
  Radio,
  Alert,
} from "antd";
import {
  ClockCircleOutlined,
  DownloadOutlined,
  LeftOutlined,
  PlusOutlined,
  UploadOutlined,
  SendOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { useState, useRef, useLayoutEffect } from "react";
import UploadIcon from "../../assets/images/upload-contant-icon.svg";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import { Severty, ShowToast } from "../../helper/toast";
import * as pdfjsLib from "pdfjs-dist/webpack";
import mammoth from "mammoth";
import moment from "moment";
import Tesseract from "tesseract.js";
import dayjs from "dayjs";
import LinkedInArticleEditor from "../../components/LinkedInArticleEditor";
import { convertHtmlToLinkedInStyledText } from "../../helper/linkedinTextFormatter";
import apiPath from "../../constants/apiPath";
import { selectionInsideElement, findOccurrenceIndex, buildCommentHighlights } from "../../helper/writingSelection";
const { Option } = Select;
const { TextArea } = Input;
const htmlToPlainText = (html) => {
  if (!html) return "";
  const temp = document.createElement("div");
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || "";
};

const ARTICLE_WORD_LIMIT = 3000;

const getWordCount = (text = "") => {
  const words = text.trim().match(/\S+/g);
  return words ? words.length : 0;
};

const slugify = (value = "") =>
  value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "article";

const getPublicArticleBaseUrl = () => {
  const configuredBase = (process.env.REACT_APP_PUBLIC_BLOG_BASE_URL || "").trim();

  if (
    configuredBase &&
    !/^https?:\/\/(www\.)?imergey\.com\/blog\/client/i.test(configuredBase)
  ) {
    return configuredBase.replace(/\/+$/, "");
  }

  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin.replace(/\/+$/, "")}/blog/client`;
  }

  return "";
};

const getPublicArticleUrl = (articleId, title = "") =>
  articleId
    ? `${getPublicArticleBaseUrl()}/${articleId}`
    : "";

const cleanLinkedInShareText = (value = "") =>
  String(value || "")
    .replace(/read\s+full\s+article\s+here:?\s*/gi, " ")
    .replace(/read\s+the\s+full\s+article:?\s*/gi, " ")
    .replace(/https?:\/\/\S+/gi, " ")
    .replace(/\s+\n/g, "\n")
    .replace(/\n\s+/g, "\n")
    .replace(/[ \t]+/g, " ")
    .trim();

const resolveAttachmentUrl = (value) => {
  if (Array.isArray(value)) {
    return value[0]?.url || value[0]?.thumbUrl || "";
  }

  if (value && typeof value === "object") {
    return value.url || value.thumbUrl || "";
  }

  return value || "";
};

const isVideoAsset = (url = "") =>
  /\.(mp4|mov|webm|m4v)(\?|$)/i.test(url);

const getBrowserTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

const getTimezoneOffsetForSchedule = (dateValue, timeValue) => {
  if (!dateValue || !timeValue) {
    return new Date().getTimezoneOffset();
  }

  const [year, month, day] = String(dateValue).split("-").map(Number);
  const [hours, minutes] = String(timeValue).split(":").map(Number);

  if (
    [year, month, day, hours, minutes].some(
      (part) => Number.isNaN(part) || part == null
    )
  ) {
    return new Date().getTimezoneOffset();
  }

  return new Date(year, month - 1, day, hours, minutes, 0, 0).getTimezoneOffset();
};

const statusMap = {
  Pending: { color: "gold", label: "Under Review" },
  Approved: { color: "green", label: "Approved" },
  Declined: { color: "red", label: "Declined" },
  draft: { color: "grey", label: "Draft" },
  "Requested Changes": { color: "blue", label: "Requested Changes" },
};

const normalizeBlogAction = (value = "") =>
  String(value || "").trim().toLowerCase();

const getBlogWorkflowPayload = (action) => {
  const normalizedAction = normalizeBlogAction(action);

  switch (normalizedAction) {
    case "draft":
      return {
        status: "Draft",
        brandStatus: "Draft",
        clientStatus: "Draft By Admin",
      };
    case "review":
      return {
        status: "Sent For Approval",
        brandStatus: "Sent For Review",
        clientStatus: "Under Review",
      };
    case "approved":
      return {
        status: "Approved",
        brandStatus: "Approved",
        clientStatus: "Approved By Client",
      };
    case "publish":
      return {
        status: "Published",
        brandStatus: "Publish",
        clientStatus: "Publish By Admin",
      };
    default:
      return {
        status: action,
        brandStatus: action,
        clientStatus: action,
      };
  }
};

const getCommentStyle = (type) => ({
  background: type === "Brand" ? "#e6f7ff" : "#fff1f0",
  border: `1px solid ${type === "brand" ? "#91d5ff" : "#ffa39e"}`,
  color: "#333",
  padding: "10px 12px",
  borderRadius: "12px",
  maxWidth: "70%",
  wordBreak: "break-word",
});
const CreateNewManuallyBlogIndex = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [attachment, setAttachment] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState("draft");
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [total, setTotal] = useState(0);
  const [searchText, setSearchText] = useState("");
  const initialEditData = location.state?.record || null;
  const initialCreateMode = !initialEditData && location.state?.mode === "create";
  const [selectedDate, setSelectedDate] = useState(location.state?.selectedDate || null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [publishOption, setPublishOption] = useState("now");
  // Shared planning-notes thread — Client/BM/BS/Admin can all add to it;
  // it's what the client sees on this blog's "In Planning" preview while
  // it's still pre-review (see ContentVisibilityHelper.buildBlogDraftPreview),
  // and stays visible afterward too as a running log. Mirrors FullCalender.js's
  // own planningNotes/planningNoteDraft — staff previously had no way at all
  // to see or reply to a blog's thread here, only the client side could.
  const [planningNotes, setPlanningNotes] = useState([]);
  const [planningNoteDraft, setPlanningNoteDraft] = useState("");
  // Was an auto-generated internal "hosted article" URL the app made up on
  // publish — replaced per direct request with a plain link the user pastes
  // in themselves (e.g. wherever they actually posted this manually, such
  // as LinkedIn), since there's no real external publish happening here.
  const [publishLink, setPublishLink] = useState("");
  const [markingPublished, setMarkingPublished] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [actionType, setActionType] = useState("draft");
  const [downloadingFormat, setDownloadingFormat] = useState("");
  const [articleShareText, setArticleShareText] = useState(
    cleanLinkedInShareText(location.state?.record?.postText || "")
  );
  const { request } = useRequest();
  const [form] = Form.useForm();
  const [editData, setEditData] = useState(initialEditData);
  const [editMode, setEditMode] = useState(Boolean(initialEditData));
  // Approve/Request Changes on any blog. Unlike Brand's old equivalent,
  // Admin isn't gated on being one of the client's assigned
  // brandStrategist/brandHead reviewers — an Admin account can never
  // legitimately be one of those (different collection entirely) — see the
  // backend's internalReviewDecision(..., { bypassAssignedReviewerCheck:
  // true }). No longer gated on internalReview.status === "pending" either
  // — Admin outranks the formal review workflow itself (Admin > BS > BM),
  // same relaxation now given to brand-manager's own canReviewBlog for
  // BS/BH, so Admin isn't left with LESS access than a Brand Strategist.
  // Still excludes an already-approved blog — nothing left to decide on
  // it until a new review cycle reopens it.
  const canReviewBlog = editData?.internalReview?.status !== "approved";
  const [createMode, setCreateMode] = useState(initialCreateMode);
  const [isFormEditable, setIsFormEditable] = useState(initialCreateMode);
  const lastCommentData = editData?.commentData;
  const [editorContent, setEditorContent] = useState("");
  const [editorKey, setEditorKey] = useState(0);
  // "Revision Submitted" flow — mirrors brand-manager-Imergey's
  // CreateBlogManually.js. See its own comment for the full explanation.
  const [newDraftHtml, setNewDraftHtml] = useState(null);
  const [newDraftAt, setNewDraftAt] = useState(null);
  const [loadingNewDraft, setLoadingNewDraft] = useState(false);
  const [showingPreviousVersion, setShowingPreviousVersion] = useState(false);
  // ── Highlight-and-comment on the article itself ─────────────────────────
  // Mirrors brand-manager-Imergey's CreateBlogManually.js — see its own
  // comment for the full explanation. Admin only gets the "Add Comment"
  // half (no separate Request Changes button here) since Admin's
  // canReviewBlog/handleBlogReviewDecision already has unrestricted
  // Approve/Request Changes access — no second path needed.
  const referenceWrapperRef = useRef(null);
  // Saving a comment swaps the pane's HTML (new highlight), which resets its
  // scroll — and can clamp the page scroll — back to the top. Remember both
  // and put them back after the refresh so the reader stays where they were.
  const highlightPaneRef = useRef(null);
  const paneScrollTop = useRef(0);
  const pageScrollY = useRef(0);
  useEffect(() => {
    const onScroll = () => { pageScrollY.current = window.scrollY; };
    window.addEventListener("scroll", onScroll, true);
    return () => window.removeEventListener("scroll", onScroll, true);
  }, []);
  useLayoutEffect(() => {
    if (highlightPaneRef.current && paneScrollTop.current) {
      highlightPaneRef.current.scrollTop = paneScrollTop.current;
    }
    if (pageScrollY.current && window.scrollY === 0) {
      window.scrollTo(0, pageScrollY.current);
    }
  }, [editData?.commentData]);
  const [pendingHighlight, setPendingHighlight] = useState(null);
  const [highlightCommentDraft, setHighlightCommentDraft] = useState("");
  const [savingHighlightComment, setSavingHighlightComment] = useState(false);
  const [activeHighlightPopup, setActiveHighlightPopup] = useState(null);
  const [clientProfile, setClientProfile] = useState({});
  const [articleTitle, setArticleTitle] = useState(
    location.state?.record?.topic || ""
  );
  const getArticleContentStats = (html = "") => {
    const plainText = htmlToPlainText(html || "").trim();

    return {
      characterCount: plainText.length,
      wordCount: getWordCount(plainText),
    };
  };
  const validateArticleWordLimit = (html) => {
    const { wordCount } = getArticleContentStats(html);

    if (wordCount > ARTICLE_WORD_LIMIT) {
      ShowToast("Word count limit exceeded", Severty.ERROR);
      return false;
    }

    return true;
  };

  useEffect(() => {
    if (!id) return;

    request({
      url: `${apiPath.getClients}/${id}`,
      method: "GET",
      onSuccess: (data) => setClientProfile(data?.data?.clients || {}),
    });
    // Load the client displayed as the LinkedIn author in the staff preview.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (editData) {
      let query = [];
      if (page) query.push(`page=${page}`);
      if (limit) query.push(`limit=${limit}`);
      if (searchText) query.push(`name=${encodeURIComponent(searchText)}`);
      if (selectedDate)
        query.push(`date=${moment(selectedDate).format("YYYY-MM-DD")}`);
      const queryString = query.length ? `?${query.join("&")}` : "";
      request({
        url: `/admin/access-module/get-blog-history/${id}/${editData._id}`,
        method: "GET",
        onSuccess: (data) => {
          if (data.status === 200) {
            setData(data.data.blogs || []);
            setTotal(data.data.total || 0);
          } else {
            setData([]);
            setTotal(0);
          }
        },
        onError: () => {
          setData([]);
          setTotal(0);
        },
        onFinally: () => setLoading(false),
      });
      form.setFieldsValue(editData);
      setArticleTitle(editData.topic || "");
      setArticleShareText(
        editData.postText && editData.postText !== editData.content
          ? cleanLinkedInShareText(editData.postText)
          : ""
      );
      if (editData.content) {
        form.setFieldsValue({ content: editData.content });
        setEditorContent(editData.content || "");
        setEditorKey((prev) => prev + 1);
      }
      if (editData.attachment) {
        setAttachment([{ url: editData.attachment }]);
      }
      // Root cause of "created for the 16th, but Send for Internal Review
      // put it back on today" — selectedDate/publishOption were never
      // populated from the loaded blog at all, so they stayed at their
      // create-mode defaults (null / "now"). handleSubmit's finalDate logic
      // then had no real date to preserve and always fell into the "now"
      // branch, stamping today's date on every single save of an existing
      // blog, review or otherwise. Mirrors FullCalender.js's own post-load
      // effect (setSelectedDate/setSelectedTime/setPublishOption("later"))
      // so an already-scheduled date survives a plain status-change submit
      // exactly like it already does for Posts.
      if (editData.selectedDate) {
        setSelectedDate(moment(editData.selectedDate).format("YYYY-MM-DD"));
        setSelectedTime(editData.selectedTime || null);
        setPublishOption("later");
      }
      setPlanningNotes(Array.isArray(editData.planningNotes) ? editData.planningNotes : []);
    }
  }, [editData, form]);

  // Fetches the writer's resubmitted draft and loads it straight into the
  // editor in place of the still-saved (pre-revision) content. Mirrors
  // brand-manager-Imergey's CreateBlogManually.js — see its own comment.
  useEffect(() => {
    if (editData?.brandStatus !== "Revision Submitted" || !editData?.blogWriteRequestId) return;
    setLoadingNewDraft(true);
    request({
      url: apiPath.blogWriteRequestVersions(editData.blogWriteRequestId),
      method: "GET",
      onSuccess: (data) => {
        const versions = data?.data?.versions || [];
        const latest = versions[0];
        if (!latest?._id) {
          setLoadingNewDraft(false);
          return;
        }
        request({
          url: apiPath.blogWriteRequestVersionHtml(editData.blogWriteRequestId, latest._id),
          method: "GET",
          // useRequest's `request()` has no onFinally support at all (it's
          // never destructured/called in the hook) — relying on it here
          // left this banner stuck on "loading it now…" forever, since
          // setLoadingNewDraft(false) never ran on either outcome. Set it
          // explicitly in both onSuccess and onError instead.
          onSuccess: (htmlRes) => {
            const html = htmlRes?.data?.html || "";
            setNewDraftHtml(html);
            setNewDraftAt(latest?.created_at || latest?.createdAt || null);
            form.setFieldsValue({ content: html });
            setEditorContent(html);
            setEditorKey((prev) => prev + 1);
            setLoadingNewDraft(false);
          },
          onError: () => setLoadingNewDraft(false),
        });
      },
      onError: () => setLoadingNewDraft(false),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editData?._id]);

  const toggleDraftVersion = () => {
    if (showingPreviousVersion) {
      form.setFieldsValue({ content: newDraftHtml || "" });
      setEditorContent(newDraftHtml || "");
    } else {
      form.setFieldsValue({ content: editData?.content || "" });
      setEditorContent(editData?.content || "");
    }
    setEditorKey((prev) => prev + 1);
    setShowingPreviousVersion((prev) => !prev);
  };

  const handleSubmit = (values, status, action = actionType) => {
    const user = JSON.parse(localStorage.getItem("admin_userProfile"));
    const name = user.user.name;
    const plainContent = htmlToPlainText(values.content || "").trim();

    if (!validateArticleWordLimit(values.content || "")) {
      return;
    }

    setLoading(true);
    const articleTitle =
      (values.topic || "").trim() || plainContent.split("\n")[0] || "Untitled article";
    const articleOutline = (values.outline || "").trim() || articleTitle;
    // Was auto-generated (getPublicArticleUrl -> an internal hosted-article
    // page nobody asked to publish to) — now the link the user actually
    // typed into the Publish modal (where they really posted this, e.g.
    // LinkedIn), stored as-is. Falls back to the internal URL only for a
    // non-publish save (draft), where there's no user-provided link yet and
    // this value is never shown/used as a real external link.
    const articleLink = (values.link || "").trim() || getPublicArticleUrl(editData?._id || id, articleTitle);
    const articlePublicUrl = articleLink;
    const fallbackShareText =
      htmlToPlainText(values.content || "")
        .replace(/\s+/g, " ")
        .trim()
        .slice(0, 320) || articleTitle;
    const linkedInPostText = convertHtmlToLinkedInStyledText(
      articleShareText || fallbackShareText
    ).trim();

    const isScheduledPublish =
      publishOption === "later" && Boolean(selectedDate && selectedTime);
    const effectivePublishOption = isScheduledPublish ? "later" : "now";
    let finalDate = selectedDate;
    let finalTime = selectedTime;

    // isScheduledPublish requiring BOTH date and time is correct for what it
    // actually gates below (status: "Scheduled" — a genuine auto-publish
    // commitment, which can't happen without a time). But finalDate/finalTime
    // used to be gated on that SAME flag, which meant any save of a blog that
    // has a date but no time — every Blog Write request's auto-promoted
    // Draft, since that flow deliberately never asks for a time (blogs are
    // never auto-published from the app) — fell into the "now" branch and
    // silently stamped today's date on every single save, including a plain
    // "Send for Internal Review". Preserving the existing date only needs a
    // date to exist, not a time too.
    if (!selectedDate) {
      const now = moment();
      finalDate = now.format("YYYY-MM-DD");
      finalTime = now.format("HH:mm");
    }

    const timezone = getBrowserTimezone();
    const timezoneOffset = getTimezoneOffsetForSchedule(finalDate, finalTime);
    const workflowPayload = getBlogWorkflowPayload(action);

    request({
      url: editData?._id ? `/admin/access-module/edit-blog/${editData._id}` : `/admin/access-module/addBlog/${id}`,
      method: editData?._id ? "PUT" : "POST",
      data: {
        ...values,
        topic: articleTitle,
        outline: articleOutline,
        link: articleLink,
        canonicalUrl: articlePublicUrl,
        linkedinShareUrl: articlePublicUrl,
        articlePublicUrl,
        articlePublicBaseUrl: getPublicArticleBaseUrl(),
        articleSlug: slugify(articleTitle),
        publishMode: "hosted_article_link",
        blogType: "manual",
        name,
        attachment: attachment && attachment[0]?.url,
        status: isScheduledPublish ? "Scheduled" : workflowPayload.status,
        selectedDate: finalDate,
        selectedTime: finalTime === "null" ? null : finalTime,
        timezone,
        timezoneOffset,
        publishOption: effectivePublishOption,
        isScheduled: isScheduledPublish,
        action: action,
        postText: linkedInPostText,
        media: attachment && attachment[0]?.url ? [attachment[0].url] : [],
        brandStatus: workflowPayload.brandStatus,
        clientStatus: workflowPayload.clientStatus,
      },
      onSuccess: (data) => {
        if (data.status === 200) {
          setLoading(false);
          ShowToast(
            // `Blog ${editMode ? "updated" : "created"} successfully`,
            data.message,
            Severty.SUCCESS
          );
          navigate(-1);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: () => {
        ShowToast(
          `Error ${editMode ? "updating" : "creating"} blog`,
          Severty.ERROR
        );
      },
      onFinally: () => setLoading(false),
    });
  };

  // Same endpoint/route FullCalender.js's own submitPlanningNote already
  // hits for Posts (/post/:id/planning-note) — the controller now falls
  // back to Blog when no matching Post exists, so no new route was needed.
  const submitPlanningNote = async () => {
    if (!planningNoteDraft.trim() || !editData?._id) return;
    try {
      const res = await request({
        url: `/admin/access-module/post/${editData._id}/planning-note`,
        method: "PUT",
        data: { text: planningNoteDraft },
      });
      if (res?.status === 200) {
        setPlanningNotes(res.data?.planningNotes || []);
        setPlanningNoteDraft("");
      } else {
        ShowToast(res?.message || "Failed to add note", Severty.ERROR);
      }
    } catch {
      ShowToast("Failed to add note", Severty.ERROR);
    }
  };

  // Admin's override version of Brand's handleBlogReviewDecision — hits
  // Admin's own internal-review-decision route (bypasses the
  // assigned-reviewer check server-side, see canReviewBlog's comment above).
  const deleteBlogComment = (commentId) => {
    if (!editData?._id || !commentId) return;
    Modal.confirm({
      title: lang("Remove this comment?"),
      content: lang("The comment and any replies to it will be removed for everyone."),
      okText: lang("Remove"),
      okButtonProps: { danger: true },
      onOk: () =>
        new Promise((resolve) => {
          request({
            url: `/admin/access-module/blog/${editData._id}/comment/${commentId}`,
            method: "DELETE",
            onSuccess: (data) => {
              resolve();
              if (data.status === 200) {
                ShowToast("Comment removed", Severty.SUCCESS);
                setActiveHighlightPopup(null);
                setEditData((prev) => ({ ...prev, commentData: data?.data?.blog?.commentData || [] }));
              } else {
                ShowToast(data.message, Severty.ERROR);
              }
            },
            onError: () => {
              resolve();
              ShowToast("Failed to remove comment", Severty.ERROR);
            },
          });
        }),
    });
  };

  const myAdminId = (() => {
    try {
      const p = JSON.parse(localStorage.getItem("admin_userProfile") || "null");
      return String(p?.user?._id || p?._id || "");
    } catch { return ""; }
  })();
  const handleBlogReviewDecision = (decision, override) => {
    if (!editData?._id) return;
    const comment = override?.comment ?? form.getFieldValue("commentbox");
    setLoading(true);
    request({
      url: `/admin/access-module/blog/${editData._id}/internal-review-decision`,
      method: "PUT",
      // topic/content: whatever's currently in the form — if Admin clicked
      // Edit and changed something before deciding, this is what persists
      // it. Was previously just {decision, comment}: the edit sat in local
      // form state only and vanished the moment this request completed,
      // since Approve/Request Changes never went through the normal save
      // (handleSubmit) at all. Harmless to always include — when nothing
      // was edited these are just the same values already saved, so the
      // backend's contentUpdates is a same-value no-op.
      data: {
        decision,
        comment,
        anchorText: override?.anchorText,
        anchorIndex: override?.anchorIndex,
        topic: form.getFieldValue("topic") || articleTitle,
        content: editorContent || form.getFieldValue("content"),
      },
      onSuccess: (data) => {
        setLoading(false);
        if (data.status === 200) {
          ShowToast(
            decision === "approved" ? "Content approved" : "Changes requested",
            Severty.SUCCESS
          );
          if (!override) form.resetFields(["commentbox"]);
          // Was navigate(-1) — sent the reviewer straight back to the
          // calendar with no way to see the result. Stay on this page and
          // refresh editData from the response instead.
          if (data?.data?.blog) setEditData(data.data.blog);
          override?.onDone?.(data?.data?.blog);
        } else {
          override?.setBusy?.(false);
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: () => {
        setLoading(false);
        override?.setBusy?.(false);
        ShowToast("Failed to record your decision", Severty.ERROR);
      },
    });
  };

  // Standalone comment on the blog's own thread — reused by the highlight
  // pane below (with an anchor) and available for a plain free-text note
  // too. Mirrors brand-manager-Imergey's handleAddBlogComment.
  const handleAddBlogComment = (override) => {
    if (!editData?._id) return;
    const comment = override?.comment ?? form.getFieldValue("commentbox");
    if (!comment?.trim()) {
      ShowToast("Please enter a comment", Severty.ERROR);
      return;
    }
    const setBusy = override?.setBusy || setLoading;
    setBusy(true);
    request({
      url: `/admin/access-module/edit-blog/${editData._id}`,
      method: "PUT",
      data: {
        commentbox: comment,
        anchorText: override?.anchorText,
        anchorIndex: override?.anchorIndex,
        // Whatever's currently in the editor — if Admin clicked Edit and
        // changed something before adding this comment, this is what
        // persists it. Same fix already applied to the internal-review
        // decision and brand-manager's own equivalent handlers.
        topic: articleTitle || form.getFieldValue("topic"),
        content: editorContent || form.getFieldValue("content"),
      },
      onSuccess: (data) => {
        setBusy(false);
        if (data.status === 200) {
          ShowToast("Comment added", Severty.SUCCESS);
          if (!override) form.resetFields(["commentbox"]);
          override?.onDone?.(data?.data?.blog || data?.data);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: () => {
        setBusy(false);
        ShowToast("Failed to add comment", Severty.ERROR);
      },
    });
  };

  // Comment highlights render via a read-only DOM pane (buildCommentHighlights,
  // real spans + dangerouslySetInnerHTML) that swaps in for the live editor
  // while viewing — NOT via a Draft.js decorator baked into the editor
  // itself. That was tried and reverted: react-draft-wysiwyg's Editor
  // wrapper does not reliably render a decorator regardless of whether it's
  // set on editorState or passed via its own customDecorators prop
  // (confirmed via isolated component tests in brand-manager-Imergey). This
  // DOM-based approach is the same one already proven working on the Blog
  // Writer's own "Open in Editor" view and in BlogWriteVersionEditor.js.
  const handleReferenceMouseUp = (event) => {
    if (event?.target?.closest?.("[data-highlight-popup]")) return;
    if (!selectionInsideElement(referenceWrapperRef.current)) return;
    const sel = window.getSelection();
    const text = sel ? sel.toString().trim() : "";
    if (!text || sel.rangeCount === 0) {
      setPendingHighlight(null);
      return;
    }
    const rect = sel.getRangeAt(0).getBoundingClientRect();
    if (!rect || (!rect.top && !rect.left)) {
      setPendingHighlight(null);
      return;
    }
    const wrapperRect = referenceWrapperRef.current.getBoundingClientRect();
    const anchorIndex = findOccurrenceIndex(referenceWrapperRef.current, sel.getRangeAt(0), text);
    setPendingHighlight({ text, anchorIndex, top: rect.bottom - wrapperRect.top + 6, left: rect.left - wrapperRect.left });
  };

  const handleReferenceClick = (e) => {
    const hl = e.target.closest && e.target.closest(".bwv-comment-hl");
    if (!hl) return;
    const id = hl.getAttribute("data-comment-id");
    const matches = (editData?.commentData || []).filter((c) => String(c._id) === String(id));
    if (!matches.length) return;
    const rect = hl.getBoundingClientRect();
    const wrapperRect = referenceWrapperRef.current.getBoundingClientRect();
    setActiveHighlightPopup({ comments: matches, top: rect.bottom - wrapperRect.top + 6, left: rect.left - wrapperRect.left });
  };

  const submitHighlightRequestChanges = () => {
    if (!pendingHighlight) return;
    setSavingHighlightComment(true);
    handleBlogReviewDecision("changes_requested", {
      comment: highlightCommentDraft.trim() || undefined,
      anchorText: pendingHighlight.text,
      anchorIndex: pendingHighlight.anchorIndex,
      setBusy: setSavingHighlightComment,
      onDone: (blog) => {
        setSavingHighlightComment(false);
        setPendingHighlight(null);
        setHighlightCommentDraft("");
        if (blog) setEditData(blog);
      },
    });
  };

  const submitHighlightComment = () => {
    if (!pendingHighlight || !highlightCommentDraft.trim()) return;
    handleAddBlogComment({
      comment: highlightCommentDraft.trim(),
      anchorText: pendingHighlight.text,
      anchorIndex: pendingHighlight.anchorIndex,
      setBusy: setSavingHighlightComment,
      onDone: (blog) => {
        setPendingHighlight(null);
        setHighlightCommentDraft("");
        if (blog) setEditData(blog);
      },
    });
  };

  const syncArticleFields = () => {
    const title =
      articleTitle ||
      form.getFieldValue("topic") ||
      htmlToPlainText(editorContent || form.getFieldValue("content") || "")
        .trim()
        .split("\n")[0] ||
      "";

    form.setFieldsValue({
      topic: title,
      outline: form.getFieldValue("outline") || title,
      link: form.getFieldValue("link") || "",
      content: editorContent || form.getFieldValue("content") || "",
    });
  };

  const openArticlePreview = () => {
    syncArticleFields();

    if (!validateArticleWordLimit(editorContent || form.getFieldValue("content") || "")) {
      form.validateFields(["content"]).catch(() => {});
      return;
    }

    setIsPreviewOpen(true);
  };

  const submitArticleFromPreview = async (status, action) => {
    try {
      syncArticleFields();
      await form.validateFields();
      const values = form.getFieldsValue();

      if (!validateArticleWordLimit(values.content || "")) {
        return;
      }

      setSubmitStatus(status);
      setActionType(action);

      if (action === "publish") {
        // Deliberate hand-off, not the "feels stale" case below — the
        // Mark as Published modal opens immediately in its place, which is
        // its own visible feedback.
        setIsPreviewOpen(false);
        setIsModalOpen(true);
        return;
      }

      // Was setIsPreviewOpen(false) BEFORE calling handleSubmit — closing
      // this modal (and, with it, the very Button whose `loading` prop was
      // supposed to show the request in flight) the instant Save as
      // Draft/Send for Review was clicked, before the network request
      // handleSubmit fires had even started. Between that instant close and
      // the eventual success/error toast there was nothing on screen at
      // all — exactly the "feels stale, like nothing happens" report. Now
      // the modal (and its now-actually-visible loading spinner) stays
      // open for the whole request: handleSubmit's onSuccess navigates
      // away on success (which unmounts this modal along with everything
      // else, no explicit close needed), and on error the modal simply
      // stays open with the error toast so the user can see what happened
      // and retry without redoing the whole flow.
      handleSubmit(values, status, action);
    } catch (error) {
      console.log("Validation failed:", error);
    }
  };

  // isHtml=true (DOCX, via mammoth.convertToHtml) means `text` is already
  // real HTML — use it as-is. isHtml=false (PDF/OCR, plain text with no
  // structure to preserve) still needs each line wrapped in its own <p>,
  // same as before; plain-text lines are escaped first since they were
  // never meant to be interpreted as HTML (a literal "<" or "&" in the
  // source PDF would otherwise corrupt the markup).
  const escapeHtml = (value = "") =>
    value
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");

  const handleArticleContentExtracted = (text, isHtml = false) => {
    const formattedContent = isHtml
      ? text.trim() || "<p></p>"
      : text
          .split("\n")
          .filter((line) => line.trim())
          .map((line) => `<p>${escapeHtml(line.trim())}</p>`)
          .join("") || "<p></p>";

    setEditorContent(formattedContent);
    form.setFieldsValue({ content: formattedContent });
    setEditorKey((prev) => prev + 1);
  };

  const handleDeleteArticleDraft = () => {
    const shouldClear = window.confirm(
      lang("Delete this article draft content?")
    );

    if (!shouldClear) {
      return;
    }

    setArticleTitle("");
    setArticleShareText("");
    setEditorContent("");
    setAttachment("");
    form.setFieldsValue({
      topic: "",
      outline: "",
      link: "",
      content: "",
    });
    setEditorKey((prev) => prev + 1);
  };

  const handleSearch = (value) => {
    setPage(1);
    setSearchText(value);
  };

  const handleDateChange = (date) => {
    setPage(1);
    setSelectedDate(date);
  };

  const handlePageChange = (p) => {
    setPage(p);
  };

  const articlePublicUrl = getPublicArticleUrl(
    editData?._id || id,
    articleTitle || form.getFieldValue("topic")
  );

  const handleDownloadArticle = async (format) => {
    const currentContent = editorContent || form.getFieldValue("content") || "";
    const plainContent = htmlToPlainText(currentContent).trim();
    const currentTitle =
      (articleTitle || form.getFieldValue("topic") || plainContent.split("\n")[0] || "Untitled article").trim();

    if (!plainContent) {
      ShowToast("Please add article content before downloading", Severty.ERROR);
      return;
    }

    try {
      setDownloadingFormat(format);
      const token = localStorage.getItem("admin_token") || "";
      const response = await fetch(
        `${apiPath.baseURL}admin/access-module/blog/export/${format}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            topic: currentTitle,
            content: currentContent,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to download ${format.toUpperCase()}`);
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const safeTitle = currentTitle.replace(
        /[^a-z0-9]/gi,
        "_"
      );

      link.href = downloadUrl;
      link.download = `${safeTitle}_${moment().format("YYYY-MM-DD")}.${format}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

      ShowToast(
        `Article ${format.toUpperCase()} downloaded successfully`,
        Severty.SUCCESS
      );
    } catch (error) {
      console.error(`Error downloading ${format}:`, error);
      ShowToast(`Failed to download ${format.toUpperCase()}`, Severty.ERROR);
    } finally {
      setDownloadingFormat("");
    }
  };

  const columns = [
    {
      title: lang("BLOG TITLE"),
      dataIndex: "topic",
      key: "topic",
    },

    {
      title: lang("BLOG CONTENT"),
      dataIndex: "content",
      key: "content",
      render: (text) => {
        const plain = htmlToPlainText(text);
        return (
          <Tooltip title={plain}>
            <span
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "inline-block",
                maxWidth: 200,
              }}
            >
              {plain}
            </span>
          </Tooltip>
        );
      },
    },
    {
      title: lang("STATUS"),
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const { color, label } = statusMap[status] || {
          color: "#ccc",
          label: status,
        };
        return (
          <div className="color-badge-table">
            <span
              className="color-tag polygon02"
              style={{ backgroundColor: color }}
            ></span>
            <div className="tag-name-text" style={{ color: color }}>
              {label}
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Card
        bordered={false}
        className="criclebox criclebox-fow-full tablespace mb-24"
        title={
          <div className="section-blog-headding d-flex justify-content-between w-100 align-items-center">
            <div className=" d-flex gap-2 align-items-center">
              <Button className="back-button" onClick={() => navigate(-1)}>
                <LeftOutlined />
              </Button>
              <h4>
                {createMode
                  ? lang("Create Blog")
                  : isFormEditable && editMode
                  ? lang("Edit Blog")
                  : lang("View Blog")}
              </h4>
            </div>

            <div className="d-flex gap-2 align-items-center">
              {createMode && (
                <Button
                  className="blog-send-writer-request-btn"
                  icon={<SendOutlined />}
                  onClick={() =>
                    navigate("/blog-write-requests", {
                      state: { autoOpenCreate: true, selectedDate },
                    })
                  }
                >
                  {lang("Send Request to Blog Writer")}
                </Button>
              )}
              <>
                <Button
                  onClick={() => handleDownloadArticle("pdf")}
                  loading={downloadingFormat === "pdf"}
                  icon={<DownloadOutlined />}
                >
                  {lang("Download PDF")}
                </Button>
                <Button
                  onClick={() => handleDownloadArticle("doc")}
                  loading={downloadingFormat === "doc"}
                  icon={<DownloadOutlined />}
                >
                  {lang("Download DOC")}
                </Button>
              </>

              {/* Previously only reachable through the preview modal (a
                  floating arrow icon near the editor toolbar, not
                  discoverable) — surfaced here too so it doesn't require
                  hunting for it every time. Same handler the modal's own
                  button uses. */}
              {(createMode || (editMode && isFormEditable)) && (
                <Button
                  className="submitted-btn"
                  loading={loading}
                  icon={<ClockCircleOutlined />}
                  onClick={() => submitArticleFromPreview("Sent For Approval", "review")}
                >
                  {lang("Send for Review")}
                </Button>
              )}

              {!isFormEditable && !createMode && (
                <Button
                  type="primary"
                  onClick={() => {
                    setIsFormEditable(true);
                  }}
                >
                  {lang("Edit")}
                </Button>
              )}
            </div>
          </div>
        }
      >
        {/* The calendar card's "Revision Submitted" label (set by
            BlogWriteService.uploadVersion) only tells the BM/BS a new
            version exists — a resubmitted version lives as its own
            BlogWriteFileVersion row under the Blog Write request, not on
            this Blog document (that only syncs once the request is
            re-approved and re-promoted). Rather than just linking away to
            go read it on a separate page, the new draft is fetched and
            loaded straight into the editor below by default — this banner
            now just offers a one-click toggle back to whatever was here
            before the revision. */}
        {editData?.brandStatus === "Revision Submitted" && editData?.blogWriteRequestId && (
          <Alert
            type="warning"
            showIcon
            style={{ marginBottom: 16 }}
            message={
              loadingNewDraft
                ? lang("The Blog Writer submitted a new version — loading it now…")
                : showingPreviousVersion
                  ? lang("Showing the version from before this revision.")
                  : lang("The Blog Writer submitted a new version to address your feedback — shown below.")
            }
            action={
              !loadingNewDraft && newDraftHtml !== null && (
                <Button size="small" type="primary" onClick={toggleDraftVersion}>
                  {showingPreviousVersion ? lang("Show New Draft") : lang("Show Previous Version")}
                </Button>
              )
            }
          />
        )}
        <div className="section-headding">
          <div></div>
        </div>
        <section className="research-container">
          <div className="sidebar-left-research" style={{ maxWidth: "100%" }}>
            <Form
              layout="vertical"
              form={form}
              onFinish={(values) => {
                // If publish was clicked, it will be handled by modal
                if (actionType !== "publish") {
                  handleSubmit(values, submitStatus);
                }
              }}
              disabled={editMode && !isFormEditable}
            >
              <Form.Item name="topic" hidden>
                <Input />
              </Form.Item>
              <Form.Item name="outline" hidden>
                <Input />
              </Form.Item>
              <Form.Item name="link" hidden>
                <Input />
              </Form.Item>
              <Row gutter={[12, 12]}>
                <Col span={24}>
                  {/* Highlight-and-comment popups (below) position themselves
                      relative to this wrapper, and selecting text anywhere
                      inside it — including inside the read-only pane —
                      starts a new anchored comment. The pane and the live
                      editor are NOT mutually exclusive while editing: the
                      editor itself can't show the highlight
                      (react-draft-wysiwyg doesn't render a decorator), so
                      the pane stays visible above it while making edits.
                      In View mode only the pane shows. Mirrors
                      brand-manager-Imergey's CreateBlogManually.js. */}
                  <div style={{ position: "relative" }} ref={referenceWrapperRef} onMouseUp={handleReferenceMouseUp}>
                    {(!editMode || isFormEditable) ? (
                      <Form.Item
                        name="content"
                        rules={[
                          { required: true, message: lang("Please enter the content") },
                          {
                            validator: (_, value) =>
                              getArticleContentStats(value).wordCount > ARTICLE_WORD_LIMIT
                                ? Promise.reject(new Error("Word count limit exceeded"))
                                : Promise.resolve(),
                          },
                        ]}
                      >
                        <LinkedInArticleEditor
                          key={editorKey}
                          content={editorContent}
                          coverMedia={attachment}
                          onCoverChange={setAttachment}
                          // Publishes under the CLIENT's own LinkedIn
                          // identity, not whichever staff member is
                          // currently editing.
                          authorName={clientProfile?.name}
                          authorImage={clientProfile?.image || clientProfile?.profileImage}
                          onChange={(html) => {
                            setEditorContent(html);
                            form.setFieldsValue({ content: html });
                            form.validateFields(["content"]).catch(() => {});
                          }}
                          title={articleTitle}
                          onTitleChange={(value) => {
                            setArticleTitle(value);
                            form.setFieldsValue({
                              topic: value,
                              outline: form.getFieldValue("outline") || value,
                              link:
                                form.getFieldValue("link") ||
                                "",
                            });
                          }}
                          titlePlaceholder={lang("Title")}
                          articleLabel={lang("Individual article")}
                          placeholder={lang("Write your article...")}
                          disabled={editMode && !isFormEditable}
                          onPreview={openArticlePreview}
                          onDelete={handleDeleteArticleDraft}
                          toolbarActions={
                            <UploadContentButton
                              onContentExtracted={handleArticleContentExtracted}
                              variant="toolbar"
                            />
                          }
                        />
                      </Form.Item>
                    ) : null}

                    {/* Moved below the editor (was above it) per direct
                        request. Mirrors brand-manager-Imergey's own move. */}
                    {editMode && (
                      <div
                        ref={highlightPaneRef}
                        onScroll={(e) => { paneScrollTop.current = e.currentTarget.scrollTop; }}
                        onClick={handleReferenceClick}
                        style={{
                          maxHeight: isFormEditable ? 260 : 500, overflowY: "auto", background: "#fff",
                          border: "1px solid #ddd", borderRadius: 8, padding: "14px 16px",
                          fontSize: 14, lineHeight: 1.6, marginBottom: 12,
                        }}
                        dangerouslySetInnerHTML={{
                          __html:
                            buildCommentHighlights(
                              editorContent || form.getFieldValue("content") || "",
                              // A comment's anchor was made against a PAST
                              // state of the article. Ways an old one
                              // resurfaces stale: (1) the writer resubmits —
                              // this pane defaults to the NEW draft, so only
                              // show it while actually viewing the previous
                              // version; (2) anyone looks again after the
                              // current feedback cycle was already resolved
                              // (commentsResolvedAt — set on internal-review
                              // approval, sendToClient, and
                              // overrideSendToClient, so this also covers a
                              // CLIENT's own old "Request Changes" comment) —
                              // anything anchored before that belongs to an
                              // already-resolved cycle. Mirrors
                              // brand-manager-Imergey's own fix.
                              // On the writer's new draft, only comments made
                              // after it arrived (the viewer's own fresh ones)
                              // highlight; earlier anchors belong to the
                              // previous version.
                              (editData?.commentData || []).filter(
                                (c) =>
                                  c.anchorText &&
                                  (!editData?.commentsResolvedAt ||
                                    new Date(c.time || 0) > new Date(editData.commentsResolvedAt)) &&
                                  (!newDraftHtml || showingPreviousVersion ||
                                    (newDraftAt && new Date(c.time || 0) > new Date(newDraftAt)))
                              )
                            ) || `<p style="color:#999;">${lang("No article content yet.")}</p>`,
                        }}
                      />
                    )}

                    {editMode && pendingHighlight && (
                      <div
                        data-highlight-popup
                        style={{
                          position: "absolute", top: pendingHighlight.top, left: pendingHighlight.left,
                          zIndex: 1100, background: "#fff", border: "1px solid #e8e8e8", borderRadius: 10,
                          boxShadow: "0 8px 24px rgba(0,0,0,0.12)", padding: 12, width: 300,
                        }}
                      >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
                          <span style={{ fontSize: 13, fontWeight: 600, color: "#333" }}>{lang("Comment on selected text")}</span>
                          <CloseOutlined
                            style={{ cursor: "pointer", fontSize: 12, color: "#999", background: "transparent", border: "none", padding: 0, boxShadow: "none", marginTop: 2 }}
                            onClick={() => { setPendingHighlight(null); setHighlightCommentDraft(""); }}
                          />
                        </div>
                        <p style={{ fontSize: 12, color: "#888", fontStyle: "italic", margin: "0 0 8px", maxHeight: 40, overflow: "hidden", lineHeight: 1.4 }}>
                          "{pendingHighlight.text.length > 80 ? pendingHighlight.text.slice(0, 80) + "…" : pendingHighlight.text}"
                        </p>
                        <TextArea
                          rows={2}
                          autoFocus
                          placeholder={lang("What needs to change here?")}
                          value={highlightCommentDraft}
                          onChange={(e) => setHighlightCommentDraft(e.target.value)}
                          disabled={false}
                          style={{ borderRadius: 6, marginBottom: 10 }}
                        />
                        <Button
                          type="primary"
                          size="middle"
                          block
                          loading={savingHighlightComment}
                          disabled={!highlightCommentDraft.trim()}
                          onClick={submitHighlightComment}
                        >
                          {lang("Add Comment")}
                        </Button>
                        {canReviewBlog && (
                          <Button
                            danger
                            size="middle"
                            block
                            style={{ marginTop: 8 }}
                            loading={savingHighlightComment}
                            disabled={false} onClick={submitHighlightRequestChanges}
                          >
                            {lang("Request Changes")}
                          </Button>
                        )}
                      </div>
                    )}

                    {editMode && activeHighlightPopup && (
                      <div
                        data-highlight-popup
                        style={{
                          position: "absolute", top: activeHighlightPopup.top, left: activeHighlightPopup.left,
                          zIndex: 1100, background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8,
                          boxShadow: "0 4px 16px rgba(0,0,0,0.15)", padding: "10px 26px 8px 12px", width: 280,
                          maxHeight: 240, overflowY: "auto",
                        }}
                      >
                        <CloseOutlined
                          style={{
                            position: "absolute", top: 10, right: 10, cursor: "pointer", fontSize: 10, color: "#999",
                            background: "transparent", border: "none", padding: 0, lineHeight: 1, boxShadow: "none",
                          }}
                          onClick={() => setActiveHighlightPopup(null)}
                        />
                        {activeHighlightPopup.comments.map((c, i) => (
                          <div
                            key={c._id}
                            style={{
                              marginBottom: 10, paddingTop: i === 0 ? 0 : 8,
                              borderTop: i === 0 ? "none" : "1px solid #f0f0f0",
                            }}
                          >
                            <div style={{ fontSize: 12, fontWeight: 600, color: "#333" }}>
                              {c.commentUserName || "Team member"}
                            </div>
                            {c.isDraft && (
                              <div style={{ fontSize: 11, color: "#d46b08", marginBottom: 2 }}>
                                {lang("Draft — only you can see this until you click Request Changes")}
                              </div>
                            )}
                            <div style={{ fontSize: 13, color: "#444", margin: "3px 0 6px" }}>{c.comment}</div>
                            {String(c.commentUserId?._id || c.commentUserId || "") === myAdminId && (
                              <span
                                role="button"
                                tabIndex={0}
                                onClick={() => deleteBlogComment(c._id)}
                                onKeyDown={(e) => { if (e.key === "Enter") deleteBlogComment(c._id); }}
                                style={{
                                  display: "inline-block",
                                  fontSize: 12,
                                  lineHeight: "16px",
                                  color: "#ff4d4f",
                                  cursor: "pointer",
                                  background: "none",
                                  border: "none",
                                  padding: 0,
                                  marginTop: 2,
                                }}
                              >
                                {lang("Remove")}
                              </span>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  {editMode && (
                    <>
                      {/* {lastComment && (
                                          <div style={{ marginBottom: 8, padding: 10, background: "#f5f5f5", borderRadius: 5 }}>
                                            <strong>Last Comment:</strong>
                                            <p style={{ margin: 0 }}>{lastComment}</p>
                                          </div>
                                        )} */}

                      <div style={{ marginBottom: 12 }}>
                        <label
                          style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            display: "block",
                            marginBottom: 6,
                          }}
                        >
                          {lang("Comments")}
                        </label>

                        <div
                          style={{
                            maxHeight: "300px",
                            overflowY: "auto",
                            background: "#fafafa",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            padding: "10px",
                          }}
                        >
                          {lastCommentData?.length > 0 ? (
                            lastCommentData
                              .slice()
                              .reverse()
                              .map((data, index) => {
                                const isBrand = data.type === "brand";

                                return (
                                  <div
                                    key={index}
                                    style={{
                                      display: "flex",
                                      justifyContent: isBrand
                                        ? "flex-end"
                                        : "flex-start",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <div style={getCommentStyle(data.type)}>
                                      {data.isDraft && (
                                        <div style={{ fontSize: 11, color: "#d46b08", marginBottom: 2 }}>
                                          {lang("Draft — only you can see this until you click Request Changes")}
                                        </div>
                                      )}
                                      <div
                                        style={{
                                          fontSize: 14,
                                          marginBottom: 4,
                                        }}
                                      >
                                        {data.comment}
                                      </div>
                                      <div
                                        style={{ fontSize: 12, color: "#888" }}
                                      >
                                        <strong>By:</strong>{" "}
                                        {data.commentUserId?.name || data.commentUserName} ({data.type}{" "}
                                        ) |{" "}
                                        {dayjs(data.time).format(
                                          "DD MMM YYYY, HH:mm"
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                          ) : (
                            <p
                              style={{
                                color: "#999",
                                textAlign: "center",
                                margin: 0,
                              }}
                            >
                              {lang("No comments yet")}
                            </p>
                          )}
                        </div>
                      </div>

                      {/* Shared planning-notes thread — Client/BM/BS/Admin
                          can all add to it. This is what the client sees on
                          this blog's "In Planning" preview while it's still
                          pre-review, and stays visible afterward too.
                          Mirrors FullCalender.js's own Planning Notes panel
                          for Posts. */}
                      <div style={{ marginBottom: 12 }}>
                        <label
                          style={{
                            fontWeight: "bold",
                            fontSize: 16,
                            display: "block",
                            marginBottom: 6,
                          }}
                        >
                          {lang("Planning Notes")}{" "}
                          <span style={{ fontWeight: 400, fontSize: 12, color: "#8c8c8c" }}>
                            ({lang("visible to client")})
                          </span>
                        </label>
                        <div
                          style={{
                            maxHeight: "220px",
                            overflowY: "auto",
                            background: "#fafafa",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            padding: "10px",
                            marginBottom: 8,
                          }}
                        >
                          {planningNotes.length > 0 ? (
                            planningNotes.map((note, i) => (
                              <div key={note._id || i} style={{ marginBottom: 10 }}>
                                <div
                                  style={{
                                    fontSize: 13,
                                    whiteSpace: "pre-wrap",
                                    background: note.authorRole === "customer" ? "#e6f4ff" : "#fff",
                                    border: "1px solid #eee",
                                    borderRadius: 6,
                                    padding: "6px 10px",
                                  }}
                                >
                                  {note.text}
                                </div>
                                <div style={{ fontSize: 11, color: "#999", marginTop: 2 }}>
                                  <strong>{note.authorName || "Someone"}</strong>
                                  {" · "}
                                  {dayjs(note.time).format("DD MMM, HH:mm")}
                                </div>
                              </div>
                            ))
                          ) : (
                            <p style={{ color: "#999", textAlign: "center", margin: 0 }}>
                              {lang("No notes yet")}
                            </p>
                          )}
                        </div>
                        {/* disabled explicitly overrides the surrounding
                            <Form disabled={editMode && !isFormEditable}>
                            context (antd's Form.disabled cascades to every
                            descendant field via DisabledContext) — without
                            this, the note box and Send button silently
                            inherited "View Blog" mode's lock and did
                            nothing at all until Edit was clicked, even
                            though this thread has nothing to do with
                            editing the article content. */}
                        <div style={{ display: "flex", gap: 6 }}>
                          <TextArea
                            rows={2}
                            placeholder={lang("Add a note for the client...")}
                            value={planningNoteDraft}
                            onChange={(e) => setPlanningNoteDraft(e.target.value)}
                            disabled={false}
                          />
                          <Button type="primary" size="small" onClick={submitPlanningNote} disabled={false}>
                            {lang("Send")}
                          </Button>
                        </div>
                      </div>

                      {/* {lastCommentData.length > 0 &&
                                          lastCommentData.slice().reverse().map((data, index) => (
                                            <div
                                              key={index}
                                              style={{
                                                marginBottom: 8,
                                                padding: 10,
                                                background: "#f5f5f5",
                                                borderRadius: 5,
                                              }}
                                            >
                                              <strong>Comment:</strong>
                                              <p style={{ margin: 0 }}>{data.comment}</p>
                                            </div>
                                          ))} */}
                    </>
                  )}

                  {editMode && (
                    <>
                      <Form.Item name="commentbox" label={lang("Comment box")}>
                        <TextArea
                          placeholder={lang("please enter your comment...")}
                          rows={5}
                          className="post-input"
                        />
                      </Form.Item>
                    </>
                  )}
                </Col>
              </Row>
            </Form>
            {!isFormEditable &&
              editMode &&
              ["sent for approval", "approved"].includes(
                editData?.status?.toLowerCase()
              ) && (
                <div className="footer-writing-btn">
                {!isFormEditable &&
                  editMode &&
                  editData?.status?.toLowerCase() === "sent for approval" && (
                    <>
                      <Button
                        className="schedule-btn"
                        disabled
                        style={{
                          opacity: 0.75,
                          cursor: "not-allowed",
                        }}
                      >
                        {lang("Waiting for Client Approval")}
                      </Button>
                    </>
                  )}
                {!isFormEditable &&
                  editMode &&
                  editData?.status?.toLowerCase() === "approved" && (
                    <>
                      <Button
                        type="primary"
                        loading={loading}
                        style={{
                          backgroundColor: "#52c41a",
                          borderColor: "#52c41a",
                        }}
                        onClick={async () => {
                          try {
                            await form.validateFields();
                            setActionType("publish");
                            setIsModalOpen(true);
                          } catch (error) {
                            console.log("Validation failed:", error);
                          }
                        }}
                      >
                        {lang("Mark as Published")}
                      </Button>
                    </>
                  )}
                </div>
              )}
            {/* Approve/Request Changes on a blog a Brand Manager already
                sent for internal review — didn't exist anywhere in this
                file before (Admin had no way to act on internalReview at
                all, only Brand's Brand Strategist/Head could). Bypasses the
                assigned-reviewer check server-side, same override spirit as
                a Brand Manager's own "Override & Send to Client" — see
                canReviewBlog/handleBlogReviewDecision above. */}
            {editMode && canReviewBlog && (
              <div className="footer-writing-btn">
                <Button type="primary" loading={loading} onClick={() => handleBlogReviewDecision("approved")}>
                  {lang("Approve")}
                </Button>
                <Button
                  danger
                  type="primary"
                  loading={loading}
                  onClick={() => handleBlogReviewDecision("changes_requested")}
                >
                  {lang("Request Changes")}
                </Button>
              </div>
            )}
          </div>
        </section>
      </Card>

      <Modal
        open={isPreviewOpen}
        onCancel={() => setIsPreviewOpen(false)}
        footer={null}
        width={1100}
        centered
        className="linkedin-article-preview-modal"
        destroyOnClose
      >
        <ArticlePreview
          title={articleTitle || form.getFieldValue("topic")}
          content={editorContent || form.getFieldValue("content")}
          loading={loading}
          onDraft={() => submitArticleFromPreview("Draft", "draft")}
          onReview={() => submitArticleFromPreview("Sent For Approval", "review")}
          onPublish={() => submitArticleFromPreview("Published", "publish")}
          authorProfile={clientProfile}
        />
      </Modal>

      {/* Mark as Published Modal — was "Select publish option" / auto-
          generated a hosted article page and called that "publishing".
          There's no real external publish happening from this app — blogs
          get posted on LinkedIn directly, same as the Post section — so
          this just records that LinkedIn link and flips the status to
          Published. The Now/Schedule choice (and the date/time picker that
          came with it) is gone too, per direct request: scheduling implied
          this app would publish it later itself, which it never does
          either — this is purely a record of something already published
          externally, so there's nothing to schedule. */}
      <Modal
        className="tab_modal"
        title="Mark as Published"
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setPublishLink("");
        }}
        footer={null}
        centered
      >
        <div style={{ marginBottom: 20 }}>
          <label>LinkedIn link</label>
          <Input
            placeholder="Paste the LinkedIn link where this blog was published"
            value={publishLink}
            onChange={(e) => setPublishLink(e.target.value)}
          />
        </div>

        <Button
          type="primary"
          block
          loading={markingPublished}
          onClick={() => {
            if (!publishLink.trim()) {
              ShowToast("Please paste the LinkedIn link where this blog was published", Severty.ERROR);
              return;
            }

            if (!validateArticleWordLimit(form.getFieldValue("content") || "")) {
              form.validateFields(["content"]).catch(() => {});
              return;
            }

            // Was setIsModalOpen(false) right here — same "feels stale" bug
            // as the preview modal's Save as Draft/Send for Review (see
            // submitArticleFromPreview's comment): closing this modal
            // before handleSubmit's request even starts hid the only
            // loading feedback this click had. Modal now stays open (with
            // this Button's `loading` spinner, added above) for the whole
            // request; navigate(-1) on success unmounts it, and on error it
            // just stays open with the error toast so the user can retry.
            if (!editData?._id) {
              ShowToast("Please save this blog first, then mark it as published.", Severty.ERROR);
              return;
            }
            // The blog was posted on LinkedIn outside this app — this only
            // records the pasted link; it must never publish anything itself.
            setMarkingPublished(true);
            request({
              url: `/admin/access-module/blog/${editData._id}/mark-published-externally`,
              method: "PUT",
              data: { linkedinUrl: publishLink.trim() },
              onSuccess: (res) => {
                setMarkingPublished(false);
                if (res.status === 200) {
                  ShowToast(res.message || "Blog marked as published", Severty.SUCCESS);
                  setIsModalOpen(false);
                  setPublishLink("");
                  navigate(-1);
                } else {
                  ShowToast(res.message, Severty.ERROR);
                }
              },
              onError: (err) => {
                setMarkingPublished(false);
                ShowToast(err?.response?.data?.message || err?.message || "Something went wrong", Severty.ERROR);
              },
            });
          }}
          style={{ background: "#001529", borderColor: "#001529" }}
        >
          Mark as Published
        </Button>
      </Modal>

    </>
  );
};
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.js`;
const UploadContentButton = ({ onContentExtracted, variant = "default" }) => {
  // PDF extraction (especially the Tesseract OCR fallback for a scanned
  // page) can take several seconds with nothing on screen to show it's
  // working — same "feels stale" gap as the submit buttons above, just for
  // Import instead of Save/Publish. Real loading feedback on the button now
  // instead of it looking dead the whole time.
  const [importing, setImporting] = useState(false);

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setImporting(true);
    try {
      const fileType = file.name.split(".").pop().toLowerCase();
      let extractedText = "";

      if (fileType === "pdf") {
        const arrayBuffer = await file.arrayBuffer();
        const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const content = await page.getTextContent();
          const pageText = content.items
            .map((item) => item.str)
            .join(" ")
            .trim();

          if (pageText) {
            extractedText += pageText + "\n";
          } else {
            // Fallback to OCR
            const viewport = page.getViewport({ scale: 2 });
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            canvas.width = viewport.width;
            canvas.height = viewport.height;

            await page.render({ canvasContext: context, viewport }).promise;

            const dataUrl = canvas.toDataURL("image/png");
            const ocrResult = await Tesseract.recognize(dataUrl, "eng");
            extractedText += ocrResult.data.text + "\n";
          }
        }
      } else if (fileType === "doc" || fileType === "docx") {
        // Was mammoth.extractRawText — PLAIN TEXT ONLY, which is exactly
        // what silently destroyed every bit of formatting (bold, italic,
        // headings, lists) on import: handleArticleContentExtracted below
        // just wrapped each resulting line in a bare <p>, so a bold word in
        // the source .docx came out as plain text in the editor. mammoth's
        // convertToHtml instead maps Word's own styles to real HTML tags
        // (<strong>, <em>, <h1>-<h3>, <ul>/<li>, ...), which Draft.js's own
        // htmlToDraft parser (used everywhere else content is loaded into
        // this editor) already understands — so it now round-trips into
        // the SAME rich formatting instead of flattening to plain text.
        const arrayBuffer = await file.arrayBuffer();
        const result = await mammoth.convertToHtml({ arrayBuffer });
        extractedText = result.value;
        onContentExtracted(extractedText, true);
        ShowToast("Content extracted successfully", Severty.SUCCESS);
        return;
      } else {
        ShowToast("Only PDF or DOC/DOCX files are supported", Severty.ERROR);
        return;
      }

      if (extractedText && extractedText.trim()) {
        // Clean and format the extracted text
        const cleanedText = extractedText
          .replace(/\r\n/g, '\n') // Normalize line endings
          .replace(/\r/g, '\n')
          .replace(/\n{3,}/g, '\n\n') // Remove multiple empty lines
          .trim();

        onContentExtracted(cleanedText, false);
        ShowToast("Content extracted successfully", Severty.SUCCESS);
      } else {
        ShowToast("No content found in the file", Severty.WARNING);
      }
    } catch (error) {
      console.error("Error extracting content:", error);
      ShowToast("Error extracting content from file", Severty.ERROR);
    } finally {
      setImporting(false);
    }
  };

  return (
    <Button
      type="default"
      loading={importing}
      disabled={importing}
      className={
        variant === "toolbar"
          ? "linkedin-article-action-button linkedin-article-import-top-button"
          : "linkedin-article-import-button"
      }
      onClick={() => {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = ".pdf,.doc,.docx";
        input.onchange = handleFileUpload;
        input.click();
      }}
      style={{ marginTop: "10px" }}
    >
      {variant === "toolbar" ? (
        <UploadOutlined />
      ) : (
        <img
          src={UploadIcon}
          alt="upload"
          style={{ width: 16, marginRight: 8 }}
        />
      )}
      Import from file
    </Button>
  );
};

const ArticlePreview = ({
  title,
  content,
  loading,
  onDraft,
  onReview,
  onPublish,
  authorProfile,
}) => {
  const authorName = authorProfile?.name || "user";
  const authorImage =
    authorProfile?.image ||
    authorProfile?.profileImage ||
    "";
  const authorInitial = authorName.trim().charAt(0).toUpperCase() || "U";
  const safeTitle = title?.trim() || lang("Untitled article");
  const safeContent = content || `<p>${lang("No article content yet.")}</p>`;

  return (
    <div className="linkedin-article-preview-shell">
      {/* The "Share your article" card (share-text box + link-preview
          thumbnail) removed here per direct request — it was an extra step
          before Mark as Published was even reachable, unlike the Post
          flow's footer (FullCalender.js) where Publish sits right there
          alongside Save as Draft/Send for Review from the start. This modal
          now goes straight from the article preview to that same 3-button
          footer. shareText/coverUrl/articleUrl props (and the "Untitled
          article / No article content yet." link-preview card they fed)
          are gone with it — the share caption for wherever this actually
          gets posted still falls back to auto-generated text from the
          content itself (see handleSubmit's fallbackShareText), same as
          before this card ever existed. */}
      <div className="linkedin-article-preview-page">
        <div className="linkedin-article-preview-author">
          <div className="linkedin-article-preview-avatar">
            {authorImage ? <img src={authorImage} alt={authorName} /> : authorInitial}
          </div>
          <div>
            <div className="linkedin-article-preview-name">{authorName}</div>
            <div className="linkedin-article-preview-subtitle">
              {lang("Individual article")}
            </div>
          </div>
        </div>

        <article className="linkedin-article-preview-body">
          <h1>{safeTitle}</h1>
          <div
            className="linkedin-article-preview-content"
            dangerouslySetInnerHTML={{ __html: safeContent }}
          />
        </article>
      </div>

      <div className="linkedin-article-preview-footer">
        <Button className="schedule-btn" loading={loading} onClick={onDraft}>
          {lang("Save as Draft")}
        </Button>
        <Button className="submitted-btn" loading={loading} onClick={onReview}>
          <ClockCircleOutlined /> {lang("Send for Review")}
        </Button>
        {/* Available from this same footer, same as Publish is in the Post
            flow's footer (FullCalender.js) — no longer buried behind the
            now-removed "Share your article" card. Opens the Mark as
            Published modal (blog link input) — see submitArticleFromPreview's
            action==="publish" branch. Reuses "submitted-btn" — same class
            Send for Review uses — instead of the earlier one-off
            .blog-mark-published-btn, which only set background/color and
            fell back to antd's default height/padding/border-radius for
            everything else, visibly mismatching its siblings in this row
            (wrong height, squarer corners, no icon-text gap). submitted-btn
            already has the exact right height/padding/radius/font AND the
            same brand gradient that custom class was trying to recreate. */}
        <Button className="submitted-btn" loading={loading} onClick={onPublish}>
          <SendOutlined /> {lang("Mark as Published")}
        </Button>
      </div>
    </div>
  );
};

export default CreateNewManuallyBlogIndex;
